import React from 'react'
import PropTypes from 'prop-types'
import { Grid, Chip } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { Controller } from 'react-hook-form'
import SydLabel from '../../../../../components/commonDesign/SydLabel'
import SydButton from '../../../../../components/commonDesign/Button'
import FlexRow from '../../../../../components/molecules/FlexRow'
import StringEditor from './editors/StringEditor'
import NumberEditor from './editors/NumberEditor'
import BooleanEditor from './editors/BooleanEditor'
import SingleSelectEditor from './editors/SingleSelectEditor'
import MultiSelectEditor from './editors/MultiSelectEditor'

const useStyles = makeStyles(() => ({
  fieldContainer: {
    marginBottom: 'var(--margin-sm)',
    fontFamily: 'var(--font-sans)'
  },
  defaultBadge: {
    marginLeft: 'var(--margin-xs)',
    backgroundColor: 'var(--color-neutral-200)',
    color: 'var(--color-neutral-700)',
    fontSize: 'var(--font-size-sm)',
    height: '20px'
  },
  labelRow: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 'var(--margin-xs)'
  }
}))

function PreferenceField ({ schemaItem, formKey, profileValue, control, onResetToDefault }) {
  const classes = useStyles()

  const isAtDefault = profileValue?.levelTypeId === 1000000
  const isUserValue = profileValue?.levelTypeId === 1001

  const getEditor = (field) => {
    const editorProps = {
      value: field.value,
      onChange: field.onChange,
      onBlur: field.onBlur,
      disabled: false
    }

    switch (schemaItem.type) {
      case 'string':
        return <StringEditor {...editorProps} />

      case 'number':
        return <NumberEditor {...editorProps} />

      case 'boolean':
        return <BooleanEditor {...editorProps} />

      case 'single_select':
        return <SingleSelectEditor {...editorProps} options={schemaItem.options} />

      case 'multi_select':
        return <MultiSelectEditor {...editorProps} options={schemaItem.options} />

      default:
        return <StringEditor {...editorProps} />
    }
  }

  return (
    <Grid item xs={12} className={classes.fieldContainer}>
      <FlexRow>
        <SydLabel
          label={schemaItem.name}
          description={schemaItem.description}
        >
          <Controller
            name={formKey}
            control={control}
            render={({ field }) => getEditor(field)}
          />
        </SydLabel>

        {isAtDefault && (
          <Chip
            label='Default Value'
            size='small'
            className={classes.defaultBadge}
          />
        )}
      </FlexRow>

      {isUserValue && (
        <FlexRow className='mt-2'>
          <SydButton
            size='xs'
            variant='ghost'
            onClick={() => onResetToDefault(schemaItem.code)}
          >
            Reset to Default
          </SydButton>
        </FlexRow>
      )}
    </Grid>
  )
}

PreferenceField.propTypes = {
  schemaItem: PropTypes.shape({
    code: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    description: PropTypes.string,
    type: PropTypes.oneOf(['string', 'number', 'boolean', 'single_select', 'multi_select']).isRequired,
    options: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    }))
  }).isRequired,
  formKey: PropTypes.string.isRequired,
  profileValue: PropTypes.shape({
    value: PropTypes.any,
    levelTypeId: PropTypes.number,
    levelId: PropTypes.number
  }),
  control: PropTypes.object.isRequired,
  onResetToDefault: PropTypes.func.isRequired
}

export default PreferenceField
